import { BasicLayoutComponent } from './basic-layout/basic-layout.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FooterComponent } from './footer/footer.component';
import { TopNavigComponent } from './top-navig/top-navig.component';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { SharedModule } from '@app/modules/shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    BsDropdownModule.forRoot(),
    CollapseModule.forRoot(),
    SharedModule
  ],
  declarations: [
    BasicLayoutComponent,
    TopNavigComponent,
    FooterComponent
  ],
  exports: [
    BasicLayoutComponent,
    TopNavigComponent,
    FooterComponent,
  ]
})
export class CommonComponentsModule { }
